import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { DbNode } from '../types/node';
import { NodeService } from '../http/node-service';

export default class NodePatchStore {
    private _nodeId: number;
    private _loading = false;
    private _nodes: DbNode[] = [];

    constructor(nodeId: number = 0) {
        this._nodeId = nodeId;
        makeObservable<NodePatchStore, '_loading' | '_nodes'>(this, {
            _loading: observable,
            _nodes: observable,
            loading: computed,
            nodes: computed,
            load: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get nodes(): DbNode[] {
        return this._nodes;
    }

    async load() {
        runInAction(() => (this._loading = true));
        try {
            const answer = await NodeService.path(this._nodeId);
            runInAction(() => (this._nodes = answer.data));
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => (this._loading = false));
        }
    }
}
